import adminRequest from '@/utils/h5-admin-request'

const PREFIX = '/schools/h5admin'

function unwrap(res) {
  if (res && res.data !== undefined) return res.data
  return res
}

/** 工作台 */
export function fetchSchoolsDashboardToday() {
  return adminRequest.get(PREFIX + '/dashboard/today').then(unwrap)
}

/** 科目 */
export function fetchSchoolSubjects(params) {
  return adminRequest.get(PREFIX + '/subjects', { params }).then(unwrap)
}

export function saveSchoolSubject(data) {
  return adminRequest.post(PREFIX + '/subjects', data).then(unwrap)
}

export function updateSchoolSubject(id, data) {
  return adminRequest.put(PREFIX + '/subjects', { ...data, id }).then(unwrap)
}

export function deleteSchoolSubject(id) {
  return adminRequest.delete(PREFIX + '/subjects/' + id).then(unwrap)
}

/** 课程产品 */
export function fetchSchoolCourses(params) {
  return adminRequest.get(PREFIX + '/courses', { params }).then(unwrap)
}

export function fetchSchoolCourseDetail(id) {
  return adminRequest.get(PREFIX + '/courses/' + id).then(unwrap)
}

export function saveSchoolCourse(data) {
  return adminRequest.post(PREFIX + '/courses', data).then(unwrap)
}

export function updateSchoolCourse(id, data) {
  return adminRequest.put(PREFIX + '/courses', { ...data, id }).then(unwrap)
}

/** 班级 */
export function fetchSchoolClasses(params) {
  return adminRequest.get(PREFIX + '/classes', { params }).then(unwrap)
}

export function fetchSchoolClassDetail(id) {
  return adminRequest.get(PREFIX + '/classes/' + id).then(unwrap)
}

export function saveSchoolClass(data) {
  return adminRequest.post(PREFIX + '/classes', data).then(unwrap)
}

export function updateSchoolClass(id, data) {
  return adminRequest.put(PREFIX + '/classes', { ...data, id }).then(unwrap)
}

/** 排课 / 课次 */
export function fetchSchoolScheduleCalendar(params) {
  return adminRequest.get(PREFIX + '/schedule/calendar', { params }).then(unwrap)
}

export function fetchSchoolSessions(params) {
  return adminRequest.get(PREFIX + '/sessions', { params }).then(unwrap)
}

/** 学员 */
export function fetchSchoolStudents(params) {
  return adminRequest.get(PREFIX + '/students', { params }).then(unwrap)
}

export function fetchSchoolStudentDetail(id) {
  return adminRequest.get(PREFIX + '/students/' + id).then(unwrap)
}

export function saveSchoolStudent(data) {
  return adminRequest.post(PREFIX + '/students', data).then(unwrap)
}

export function updateSchoolStudent(id, data) {
  return adminRequest.put(PREFIX + '/students', { ...data, id }).then(unwrap)
}

/** 报名订单（线下收款） */
export function fetchSchoolEnrollOrders(params) {
  return adminRequest.get(PREFIX + '/enroll-orders', { params }).then(unwrap)
}

export function createSchoolEnrollOrder(data) {
  return adminRequest.post(PREFIX + '/enroll-orders', data).then(unwrap)
}

export function rechargeSchoolStudentLesson(studentId, data) {
  return adminRequest.post(PREFIX + '/students/' + studentId + '/lesson-recharge', data).then(unwrap)
}

export function addSchoolClassStudent(classId, studentId) {
  return adminRequest.post(PREFIX + '/classes/' + classId + '/students', { studentId }).then(unwrap)
}

export function removeSchoolClassStudent(classId, studentId) {
  return adminRequest.delete(PREFIX + '/classes/' + classId + '/students/' + studentId).then(unwrap)
}

export function saveSchoolSession(data) {
  return adminRequest.post(PREFIX + '/sessions', data).then(unwrap)
}

export function updateSchoolSession(data) {
  return adminRequest.put(PREFIX + '/sessions', data).then(unwrap)
}

export function generateSchoolSessions(data) {
  return adminRequest.post(PREFIX + '/sessions/generate', data).then(unwrap)
}

export function cancelSchoolSession(sessionId) {
  return adminRequest.post(PREFIX + '/sessions/' + sessionId + '/cancel').then(unwrap)
}

export function confirmSchoolEnrollPayment(orderNo, data) {
  return adminRequest.post(PREFIX + '/enroll-orders/' + orderNo + '/confirm-payment', data).then(unwrap)
}

/** 考勤课消 */
export function fetchSchoolLessonsByDate(params) {
  return adminRequest.get(PREFIX + '/attendance/lessons-by-date', { params }).then(unwrap)
}

export function fetchSchoolSessionAttendance(sessionId) {
  return adminRequest.get(PREFIX + '/sessions/' + sessionId + '/attendance').then(unwrap)
}

export function submitSchoolSessionAttendance(sessionId, data) {
  return adminRequest.post(PREFIX + '/sessions/' + sessionId + '/attendance/batch', data).then(unwrap)
}

/** 请假 */
export function fetchSchoolLeaveRequests(params) {
  return adminRequest.get(PREFIX + '/leave-requests', { params }).then(unwrap)
}

export function approveSchoolLeaveRequest(requestNo, data) {
  return adminRequest.post(PREFIX + '/leave-requests/' + requestNo + '/approve', data || {}).then(unwrap)
}

export function rejectSchoolLeaveRequest(requestNo, data) {
  return adminRequest.post(PREFIX + '/leave-requests/' + requestNo + '/reject', data || {}).then(unwrap)
}

/** 教师 */
export function fetchSchoolTeachers(params) {
  return adminRequest.get(PREFIX + '/teachers', { params }).then(unwrap)
}

export function saveSchoolTeacher(data) {
  return adminRequest.post(PREFIX + '/teachers', data).then(unwrap)
}

export function updateSchoolTeacher(id, data) {
  return adminRequest.put(PREFIX + '/teachers', { ...data, id }).then(unwrap)
}

/** 教室 */
export function fetchSchoolRooms(params) {
  return adminRequest.get(PREFIX + '/rooms', { params }).then(unwrap)
}

export function fetchSchoolRoomCategoryOptions() {
  return adminRequest.get(PREFIX + '/room-categories/options').then(unwrap)
}

export function fetchSchoolRoomCategories(params) {
  return adminRequest.get(PREFIX + '/room-categories', { params }).then(unwrap)
}

export function saveSchoolRoomCategory(data) {
  return adminRequest.post(PREFIX + '/room-categories', data).then(unwrap)
}

export function updateSchoolRoomCategory(id, data) {
  return adminRequest.put(PREFIX + '/room-categories', { ...data, id }).then(unwrap)
}

export function deleteSchoolRoomCategory(id) {
  return adminRequest.delete(PREFIX + '/room-categories/' + id).then(unwrap)
}

export function saveSchoolRoom(data) {
  return adminRequest.post(PREFIX + '/rooms', data).then(unwrap)
}

export function updateSchoolRoom(id, data) {
  return adminRequest.put(PREFIX + '/rooms', { ...data, id }).then(unwrap)
}

/** 通知公告 */
export function fetchSchoolNotices(params) {
  return adminRequest.get(PREFIX + '/notices', { params }).then(unwrap)
}

export function saveSchoolNotice(data) {
  return adminRequest.post(PREFIX + '/notices', data).then(unwrap)
}

export function updateSchoolNotice(id, data) {
  return adminRequest.put(PREFIX + '/notices', { ...data, id }).then(unwrap)
}

/** 机构设置 */
export function fetchSchoolOrgSetting() {
  return adminRequest.get(PREFIX + '/org/setting').then(unwrap)
}

export function saveSchoolOrgSetting(data) {
  return adminRequest.put(PREFIX + '/org/setting', data).then(unwrap)
}

/** 下拉：科目（不分页） */
export function fetchSchoolSubjectOptions() {
  return fetchSchoolSubjects({ page: 0, size: 200, status: 1 }).then(res => (res && res.content) || [])
}

/** 下拉：教师 */
export function fetchSchoolTeacherOptions() {
  return fetchSchoolTeachers({ page: 0, size: 200 }).then(res => (res && res.content) || [])
}

/** 下拉：课程 */
export function fetchSchoolCourseOptions() {
  return fetchSchoolCourses({ page: 0, size: 200, status: 1 }).then(res => (res && res.content) || [])
}

/** 机构上下文 / 平台管理 */
export function fetchSchoolsOrgSession() {
  return adminRequest.get(PREFIX + '/org/session').then(unwrap)
}

export function fetchSchoolPlatformOrgs(params) {
  return adminRequest.get(PREFIX + '/platform/orgs', { params }).then(unwrap)
}

export function createSchoolPlatformOrg(data) {
  return adminRequest.post(PREFIX + '/platform/orgs', data).then(unwrap)
}

export function updateSchoolPlatformOrg(id, data) {
  return adminRequest.put(PREFIX + '/platform/orgs/' + id, data).then(unwrap)
}
